export default "__VITE_ASSET__CdWtlF31__"